module.exports = __webpack_public_path__ + "img/39_5.dd0862f3.png";